"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./MediaInput.css");
var _Preview = require("./Preview");
var _Icons = require("../Icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//- React Imports

//- Style Imports

//- Component Imports

//- Type Imports

var MediaInput = _ref => {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Choose Media' : _ref$title,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    mediaType = _ref.mediaType,
    previewUrl = _ref.previewUrl,
    hasError = _ref.hasError,
    onChange = _ref.onChange;
  var inputFile = (0, _react.useRef)(null);
  var openUploadDialog = () => {
    var _inputFile$current;
    return (_inputFile$current = inputFile.current) === null || _inputFile$current === void 0 ? void 0 : _inputFile$current.click();
  };
  var onImageChange = event => {
    if (event.target.files && event.target.files[0]) {
      var type = event.target.files[0].type;
      if (!type.includes('image') && !type.includes('video')) return;

      // Raw data for image preview.
      var url = URL.createObjectURL(event.target.files[0]);

      // Uint8Array data for sending to IPFS.
      var bufferReader = new FileReader();
      bufferReader.readAsArrayBuffer(event.target.files[0]);
      bufferReader.onloadend = () => onChange(type.includes('image') ? 'image' : 'video', url, Buffer.from(bufferReader.result));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-media-input"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "preview-container",
    className: (0, _classnames.default)('zui-media-input-preview', className, {
      'zui-media-input-uploaded': previewUrl,
      'zui-media-input-error': hasError
    }),
    onClick: openUploadDialog
  }, mediaType && previewUrl ? /*#__PURE__*/_react.default.createElement(_Preview.Preview, {
    "data-testid": "preview",
    mediaType: mediaType,
    previewUrl: previewUrl
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-media-input-preview-text"
  }, /*#__PURE__*/_react.default.createElement(_Icons.IconFilePlus2, {
    className: 'zui-media-input-preview-text-icon'
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "zui-media-input-preview-text-title"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement("span", {
    className: "zui-media-input-preview-text-subtitle"
  }, subtitle))), /*#__PURE__*/_react.default.createElement("input", {
    "data-testid": "input",
    ref: inputFile,
    name: "media",
    type: "file",
    accept: "image/*,video/*,video/quicktime",
    multiple: false,
    onChange: onImageChange
  }));
};
exports.MediaInput = MediaInput;
//# sourceMappingURL=MediaInput.js.map